import { render, staticRenderFns } from "./aSpin.vue?vue&type=template&id=70cec74c&scoped=true&"
import script from "./aSpin.vue?vue&type=script&lang=ts&"
export * from "./aSpin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cec74c",
  null
  
)

export default component.exports